@defer {
  <ng-container [formGroup]="group()">
    <ngx-monaco-editor [formControlName]="fieldName()"
                       [options]="options()"
                       appResizeHandle
                       [hitArea]="config.mobile() ? 48 : 20" />
  </ng-container>
}
